import React from "react";
import { IGatsbyImageData } from "gatsby-plugin-image";
import GatsbyImageTag from "components/partials/parts/gatsby-image-tag";
import { ReactComponent as CaretLeftIcon } from "img/arrows/caret-left.svg";
import { ReactComponent as CaretRightIcon } from "img/arrows/caret-right.svg";
import { SvgLogoImage } from "types/svg-logo-image";

/**
 * Logo Carousel Slide
 * Suggested image size: 200x127
 */
export type LogoCarouselSlide = {
    image?: IGatsbyImageData;
    svgLogoImage?: SvgLogoImage;
    url: string;
    alt?: string;
};

export type LogoCarouselProps = {
    headline: string;
    slides: LogoCarouselSlide[];
    headingLevel?: "h2" | "h3" | "h4" | "h5" | "h6";
};

const LogoGrid: React.FC<LogoCarouselProps> = ({ headline, slides, headingLevel }) => {

    const HeadingTag = headingLevel || "h3";

    return (
        <div className="pattern">
            <div className="container">
                <HeadingTag>{headline}</HeadingTag>
                <div className="grid-container grid-container--align-center" >
                    {slides.map((slide, index) => (
                        <a href={slide.url} key={index}>
                            <GatsbyImageTag image={slide.image} svgLogoImage={slide.svgLogoImage} alt={slide.alt} />
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default LogoGrid;